import { FloatingIpsTable } from "@/admin/floating_ips/FloatingIpsTable.tsx";
import { createLazyFileRoute } from "@tanstack/react-router";

export const Route = createLazyFileRoute("/admin/_menu/_dual/floating_ips")({
    component: FloatingIpsTable,
});
